import { axiosInstance, axiosInstanceNoToken } from "./axiosConfig";

// Type definitions
export interface ContactInfo {
    id: number;
    company_phone: string;
    customer_service_phone: string;
    email: string;
    work_hours: string;
    facebook_url: string;
    instagram_url: string;
    twitter_url: string;
    linkedin_url: string;
}

export interface ContactInfoResponse {
    results: ContactInfo[];
}

export interface FeedbackRequest {
    name: string;
    email: string;
    phone: string;
    feedback: string;
}

export interface FeedbackResponse {
    success: boolean;
    message: string;
}

// API functions
export const contactAPI = {

    getContactInfo: async (): Promise<ContactInfo[]> => {
        try {
            const response = await axiosInstance.get<ContactInfoResponse>(`/core/contact_info`);
            return response.data.results;
        } catch (error) {
            console.error('Error fetching contact info:', error);
            throw error;
        }
    },


    submitFeedback: async (data: FeedbackRequest): Promise<FeedbackResponse> => {
        try {
            const response = await axiosInstanceNoToken.post<FeedbackResponse>(`/core/feedback`, data);
            return response.data;
        } catch (error) {
            console.error('Error submitting feedback:', error);
            throw error;
        }
    },
};